import { useState, useEffect } from "react";
import { GateListModalHeader } from "./GateListModalHeader";
import { GateListModalFormWrapper } from "./GateListModalFormWrapper";

const GateListModal = ({
  listing,
  selectedListingId,
  setOpenGateListModal,
  setOpenTimelineModal,
  gateLists,
  getGateLists
}) => {
  const [openGateAddModal, setOpenGateAddModal] = useState(false)

  useEffect(() => {
    document.body.classList.add("modal-open");

    return () => {
      document.body.classList.remove("modal-open");
    };
  }, []);

  return (
    <>
      <div
        className="modal fade show d-block"
        id="kt_modal_add_user"
        role="dialog"
        tabIndex={-1}
        aria-modal="true"
      >
        {/* begin::Modal dialog */}
        <div className="modal-dialog modal-dialog-centered mw-750px">
          {/* begin::Modal content */}
          <div className="modal-content">
            <GateListModalHeader
              listing={listing}
              selectedListingId={selectedListingId}
              setOpenGateListModal={setOpenGateListModal}
              setOpenTimelineModal={setOpenTimelineModal}
              setOpenGateAddModal={setOpenGateAddModal}
            />
            {/* begin::Modal body */}
            <div className="modal-body scroll-y mx-5 mx-xl-5 my-2 p-4">
              <GateListModalFormWrapper
                listing={listing}
                selectedListingId={selectedListingId}
                gateLists={gateLists}
                getGateLists={getGateLists}
                setOpenGateListModal={setOpenGateListModal}
                setOpenTimelineModal={setOpenTimelineModal}
                openGateAddModal={openGateAddModal}
                setOpenGateAddModal={setOpenGateAddModal}
              />
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className="modal-backdrop fade show"></div>
      {/* end::Modal Backdrop */}
    </>
  );
};

export { GateListModal };
